var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJpg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "jpg-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 28.992,
    viewBox: "0 0 24 28.992",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M133.084,299.638a1.281,1.281,0,0,1-.106.655q-.106.146-.479.146c-.416,0-.631-.135-.643-.405-.007-.111-.01-.206-.01-.285s-.007-.206-.02-.373h-.807l-.01.33a1.749,1.749,0,0,0,.276,1.187,1.825,1.825,0,0,0,1.2.271,1.7,1.7,0,0,0,1.156-.28,1.648,1.648,0,0,0,.284-1.141v-3.077h-.846v2.973Z",
    transform: "translate(-125.754 -279.112)",
    fill: "#fcfcfc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M195.653,296.665h-2.019v4.459h.846v-1.44h1l.2,0a1.8,1.8,0,0,0,1.216-.294,1.705,1.705,0,0,0,.3-1.19,1.24,1.24,0,0,0-1.535-1.532Zm.521,2.174a1.276,1.276,0,0,1-.73.133h-.964v-1.594h1.049a1.04,1.04,0,0,1,.671.135,1.167,1.167,0,0,1,.129.7C196.329,298.542,196.278,298.75,196.174,298.839Z",
    transform: "translate(-184.673 -279.112)",
    fill: "#fcfcfc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M261.935,298.118v.624h1.121l0,.183q0,.572-.188.726a1.594,1.594,0,0,1-.881.154,1.481,1.481,0,0,1-.908-.181,1.22,1.22,0,0,1-.2-.845l-.006-.572,0-.448a1.245,1.245,0,0,1,.2-.859,1.528,1.528,0,0,1,.933-.183,2,2,0,0,1,.845.106q.169.106.191.544h.856q0-.869-.346-1.123a2.993,2.993,0,0,0-1.536-.253,3.578,3.578,0,0,0-1.287.164,1.08,1.08,0,0,0-.565.633,6.719,6.719,0,0,0-.15,1.849,2.2,2.2,0,0,0,.375,1.519,2.247,2.247,0,0,0,1.532.373,3.043,3.043,0,0,0,1.625-.279q.365-.28.365-1.247l-.013-.886h-1.963Z",
    transform: "translate(-247.126 -278.478)",
    fill: "#fcfcfc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M44.3,0V15.686H42.189v8.261h0l2.106,2.106v2.94H66.189V6.06L60.129,0ZM63.111,23.041H43.095V16.592H63.111ZM60.58,2.187,64,5.607H60.58Z",
    transform: "translate(-42.189)",
    fill: "#fcfcfc"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpg);
export default __webpack_public_path__ + "static/media/jpg.3142b605249b7b48713ed19b8bf86483.svg";
export { ForwardRef as ReactComponent };